import React, { useContext, useEffect, useState } from "react";
import { FaCartArrowDown } from "react-icons/fa";
import { AppContext } from "./Contaxt";
import { toast } from "react-toastify";

function AddCart() {
  const [item, setItem] = useState([]);
  const { setData } = useContext(AppContext);

  useEffect(() => {
    const data = localStorage.getItem("items");
    if (item) {
      setItem(JSON.parse(data));
    }
  }, []);

  const handleDelet = (id) => {
    const newItem = item.filter((p) => p.id !== id);
    localStorage.setItem("items", JSON.stringify(newItem));
    setItem(newItem);
    setData(newItem);
    toast.warning("Item delet to cart", {
      position: "top-right",
    });
  };

  return (
    <div className="container mt-4 " style={{ height: "50vh" }}>
      {item.length ? (
        <table class="table ">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Price</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            {item.map((p) => {
              return (
                <tr>
                  <th scope="row">{p.id}</th>
                  <td>
                    <img src={p.image} alt="" style={{ width: "70px" }}></img>
                  </td>
                  <td>{p.title}</td>
                  <td>${p.price}</td>
                  <td>
                    <button
                      className="deletCart"
                      onClick={() => {
                        handleDelet(p.id);
                      }}
                    >
                      Delet Item
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <h1 style={{ marginTop: "50px" }}>
          Plz Add Item to Cart <FaCartArrowDown />
        </h1>
      )}
    </div>
  );
}

export default AddCart;
